var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconKarma(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 64,
    height: 64,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#676E74",
    d: "M26.375 52.625h11.25V64h-11.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333637",
    d: "M32 52.625h5.625V64H32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4C545A",
    d: "M22.625 47h18.75v9.375h-18.75z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#52585C",
    d: "M32 47h9.375v9.375H32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA2D",
    d: "M45.012 36.725c-2.325 1.913-3.637 4.612-3.637 7.425V47h-18.75v-2.85c0-2.85-1.238-5.512-3.3-7.125-5.062-3.938-7.95-9.862-7.95-16.275a20.585 20.585 0 017.613-16.013C22.7 1.737 27.238 0 32 0c1.462 0 2.962.15 4.425.45 8.1 1.688 14.475 8.45 15.9 16.663 1.275 7.5-1.425 14.85-7.313 19.612z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FDBF00",
    d: "M45.012 36.725c-2.325 1.913-3.637 4.612-3.637 7.425V47H32V0c1.462 0 2.962.15 4.425.45 8.1 1.688 14.475 8.45 15.9 16.663 1.275 7.5-1.425 14.85-7.313 19.612z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#676E74",
    d: "M18.875 45.125h26.25v3.75h-26.25z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9100",
    d: "M39.956 10.143l2.651 2.651-3.979 3.978-2.651-2.651z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FDBF00",
    d: "M25.372 24.727l2.651 2.651-3.979 3.979-2.651-2.651zM30.125 28.25h3.75v5.625h-3.75z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9100",
    d: "M38.628 24.727l3.979 3.979-2.651 2.651-3.979-3.979zM39.5 18.875h5.625v3.75H39.5z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FDBF00",
    d: "M24.044 10.143l3.979 3.979-2.651 2.65-3.979-3.978zM18.875 18.875H24.5v3.75h-5.625zM30.125 7.625h3.75v5.625h-3.75z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFDA2D"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 18.875h7.625v3.75H0zM6.585 14.81l-5.75-3.75 2.08-3.12 5.75 3.75zM2.915 33.56l-2.08-3.12 5.75-3.75 2.08 3.12z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FDBF00",
    d: "M56.375 18.875H64v3.75h-7.625zM61.085 33.56l-5.75-3.75 2.08-3.12 5.75 3.75zM57.415 14.81l-2.08-3.12 5.75-3.75 2.08 3.12z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9100",
    d: "M32 7.625h1.875v5.625H32zM32 28.25h1.875v5.625H32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#333637",
    d: "M32 45.125h13.125v3.75H32z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FDBF00",
    d: "M32 11.375c-5.175 0-9.375 4.2-9.375 9.375s4.2 9.375 9.375 9.375 9.375-4.2 9.375-9.375-4.2-9.375-9.375-9.375z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9100",
    d: "M32 30.125v-18.75c5.175 0 9.375 4.2 9.375 9.375s-4.2 9.375-9.375 9.375z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA2D",
    d: "M30.125 18.875h3.75v3.75h-3.75z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FDBF00",
    d: "M32 18.875h1.875v3.75H32z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconKarma);
export default __webpack_public_path__ + "static/media/icon-karma.24e0debeb1e51eaa14e295270e33df54.svg";
export { ForwardRef as ReactComponent };